export function Progress({ current, total }: { current: number; total: number }) {
  const percentage = Math.round((current / total) * 100);
  return (
    <div className="progress" aria-label={`Step ${current} of ${total}`}>
      <p><strong>Step {current} of {total}</strong><span>{percentage}% complete</span></p>
      <div className="progress__track" aria-hidden="true"><span style={{ width: `${percentage}%` }} /></div>
    </div>
  );
}
